import { createAction, props } from '@ngrx/store';
import { PredictiveStatus } from '@app/pages/dashboard/interfaces/technical-status.interfaces';
import { IProfileKpiData } from '@app/pages/dashboard/interfaces/kpi.interfaces';
import { IComfortLevel } from '@app/pages/dashboard/interfaces/building-comfort.interfaces';

export const detailedViewActivated = createAction('[Dashboard] Detailed view activated');

export const detailedViewDeactivated = createAction(
	'[Dashboard] Detailed view deactivated'
);

export const detailedViewTitleChanged = createAction(
	'[Dashboard] Detailed view title changed',
	props<{ payload: string }>()
);

export const singleBuildingViewActivated = createAction(
	'[Dashboard] Single building details opened',
	props<{ buildingId: string }>()
);

export const singleBuildingViewDeactivated = createAction(
	'[Dashboard] Single building details leave'
);

export const buildingMobileFilterActivated = createAction(
	'[Dashboard] Single building mobile filter opened'
);

export const buildingMobileFilterDeactivated = createAction(
	'[Dashboard] Single building mobile filter closed'
);

export const buildingMobileFilterToggle = createAction(
	'[Dashboard] Single building mobile filter toggled'
);

export const buildingDesktopFilterActivated = createAction(
	'[Dashboard] Single building desktop filter opened'
);

export const buildingDesktopFilterDeactivated = createAction(
	'[Dashboard] Single building desktop filter closed'
);

export const buildingDesktopFilterToggle = createAction(
	'[Dashboard] Single building desktop filter toggled'
);

export const buildingSortActivated = createAction(
	'[Dashboard] Single building mobile sort opened'
);

export const buildingSortDeactivated = createAction(
	'[Dashboard] Single building mobile sort closed'
);

export const buildingSortToggle = createAction(
	'[Dashboard] Single building sort toggled'
);

export const LoadTranslate = createAction('[Dashboard] Load Translate');

export const storeBuildingsOrTenantsFilters = createAction(
	'[Dashboard] Buildings list filters was stored',
	props<{ buildingsId: string[]; statuses: string[]; search: string }>()
);

export const storeTenantsFilters = createAction(
	'[Dashboard] Tenants list filters was stored',
	props<{ buildingsId: string[]; statuses: string[]; search: string }>()
);

export const storeZoneFilters = createAction(
	'[Dashboard] Zones list filters was stored',
	props<{ buildingsId: string[]; statuses: string[]; search: string }>()
);

export const storeComfortFilters = createAction(
	'[Dashboard] Comfort filters was stored',
	props<{
		floorId: string[];
		comfortLevel: IComfortLevel[];
		search: string;
	}>()
);

export const storeTechStatusFilters = createAction(
	'[Dashboard] TechStatuses filters was stored',
	props<{
		systemRun: boolean | 'All';
		predictive: PredictiveStatus[];
		search: string;
	}>()
);

export const searchDashboardBuildings = createAction(
	'[Dashboard] search buildings',
	props<{ buildingsId: string[]; statuses: string[]; search: string }>()
);

export const searchDashboardZones = createAction(
	'[Dashboard] search zones',
	props<{ buildingsId: string[]; statuses: string[]; search: string }>()
);

export const searchZonesFromTabUniversal = createAction(
	'[Dashboard] search zones from tab universal',
	props<{ buildingId: string[]; statuses: string[]; search: string }>()
);

export const searchZonesFromTabUniversalSuccess = createAction(
	'[Dashboard] search zones from tab universal success',
	props<{ zones: any[] }>()
);

export const searchDashboardTenants = createAction(
	'[Dashboard] search tenants',
	props<{ buildingsId: string[]; statuses: string[]; search: string }>()
);

export const searchTenantsFromTabUniversalSuccess = createAction(
	'[Dashboard] search tenants from tab universal success',
	props<{ tenants: any[] }>()
);

export const totalKPIEnergyOpen = createAction('[Dashboard] TotalKpi energy opened');

export const totalKPIEnergyClose = createAction('[Dashboard] TotalKpi energy closed');

export const totalKPIEnergyToggle = createAction('[Dashboard] TotalKpi energy toggled');

export const totalKPIComfortOpen = createAction('[Dashboard] TotalKpi comfort opened');

export const totalKPIComfortClose = createAction('[Dashboard] TotalKpi comfort closed');

export const totalKPIComfortToggle = createAction('[Dashboard] TotalKpi comfort toggled');

export const totalKPITechStatusOpen = createAction(
	'[Dashboard] TotalKpi technical status opened'
);

export const totalKPITechStatusClose = createAction(
	'[Dashboard] TotalKpi technical status closed'
);

export const totalKPITechStatusToggle = createAction(
	'[Dashboard] TotalKpi technical status toggled'
);

export const totalKpiCloseAllCards = createAction(
	'[Dashboard] TotalKpi all lock-cards closed'
);

export const totalKPIUpdateProfileData = createAction(
	'[Dashboard] TotalKpi update profile data',
	props<{ profileData: IProfileKpiData }>()
);

export const initiateTotalKpi = createAction('[Dashboard] Initiate TotalKpi');
